/* requires:
polyfill.js
*/

// display the current year in the footer
document.querySelector(".footer_year").innerHTML = new Date().getFullYear();
